import { Info } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Reveal } from "@/components/Reveal";

export default function LegalPage({ doc }) {
  const { legal } = useLang();
  const d = legal[doc];
  return (
    <div data-testid={`legal-page-${doc}`}>
      <section className="relative overflow-hidden bg-[#F8FAFC] pb-12 pt-36 lg:pt-44">
        <div className="pointer-events-none absolute -left-32 top-0 h-[360px] w-[360px] rounded-full bg-teal-200/40 blur-[120px]" />
        <div className="container-x relative max-w-4xl">
          <Reveal y={20}>
            <p className="eyebrow">SIDLY</p>
            <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.05] text-slate-900 sm:text-5xl" data-testid={`legal-${doc}-title`}>{d.title}</h1>
            <p className="mt-4 font-mono text-xs text-slate-500">{legal.updated}</p>
            {legal.notice && (
              <p className="mt-6 flex items-start gap-3 rounded-2xl border border-sky-200 bg-sky-50 p-4 text-sm leading-relaxed text-sky-900" data-testid="legal-translation-notice">
                <Info size={18} className="mt-0.5 shrink-0" />{legal.notice}
              </p>
            )}
          </Reveal>
        </div>
      </section>
      <section className="container-x max-w-4xl pb-24">
        <article className="prose-legal">
          <p className="text-base leading-relaxed text-slate-700 md:text-lg">{d.intro}</p>
          {d.sections.map((s, i) => (
            <section key={i}>
              <h2>{s.h}</h2>
              {s.blocks.map((b, j) => (
                <div key={j}>
                  {b.h3 && <h3>{b.h3}</h3>}
                  {b.p?.map((p, k) => <p key={k}>{p}</p>)}
                  {b.list && <ul>{b.list.map((li, k) => <li key={k}>{li}</li>)}</ul>}
                </div>
              ))}
            </section>
          ))}
        </article>
      </section>
    </div>
  );
}
